import React from 'react';
import { FadeIn } from './FadeIn';
export function FinalCTA() {
  return <section className="py-16 bg-surface border-t border-white/5 relative overflow-hidden" aria-label="Llamada final a la acción" data-id="element-60">
      <div className="container mx-auto px-4 max-w-4xl relative z-10 text-center" data-id="element-61">
        <FadeIn data-id="element-62">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4" data-id="element-63">
            Última oportunidad —{' '}
            <span className="text-gold" data-id="element-64">elegí tu pack</span>
          </h2>
          <p className="text-gray-400 mb-10" data-id="element-65">
            🛡️ Garantía 7 días · ⚡ Acceso inmediato · 🔒 Pago seguro
          </p>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-66">
          <a href="https://fegion.shop/cart/47115288019083:1" className="flex flex-col sm:flex-row items-center sm:items-stretch justify-between gap-4 p-5 md:p-6 bg-surfaceLight border border-white/10 rounded-2xl hover:border-white/30 transition-colors text-left mb-5 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" aria-label="Comprar SISTEMA MAESTRO COMPLETO por $19.990 ARS" data-id="element-67">
            <div className="flex-1" data-id="element-68">
              <span className="block text-base md:text-lg font-heading font-bold text-white mb-1" data-id="element-69">
                📘 SISTEMA MAESTRO COMPLETO
              </span>
              <span className="block text-xs md:text-sm text-gray-400" data-id="element-70">
                6 Módulos + 3 Bonos
              </span>
            </div>
            <div className="flex items-center gap-4 shrink-0" data-id="element-71">
              <div className="flex flex-col items-end" data-id="element-72">
                <span aria-hidden="true" className="text-gray-500 line-through text-xs" data-id="element-73">
                  $69.990
                </span>
                <span className="text-xl md:text-2xl font-heading font-bold text-white" data-id="element-74">
                  $19.990
                </span>
              </div>
              <div className="py-2.5 px-4 rounded-xl font-bold text-white border border-white/20 uppercase tracking-wider text-[11px] whitespace-nowrap" data-id="element-75">
                Lo quiero
              </div>
            </div>
          </a>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-76">
          <div className="relative my-6" data-id="element-77">
            <div className="absolute -inset-1 rounded-3xl opacity-40 blur-md pointer-events-none" aria-hidden="true" style={{
            background: 'linear-gradient(135deg, rgba(212, 168, 67, 0.5) 0%, transparent 100%)'
          }} data-id="element-78"></div>
            <a href="https://fegion.shop/cart/47115293393035:1" className="relative flex flex-col md:flex-row items-center md:items-stretch justify-between gap-5 p-7 md:p-8 bg-gold rounded-3xl hover:bg-gold-light transition-colors shadow-[0_0_30px_rgba(212,168,67,0.2)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" aria-label="Comprar SISTEMA MAESTRO + PACK DE ACELERACIÓN por $29.990 ARS" data-id="element-79">
              <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-bg text-gold border border-gold/30 font-bold px-5 py-1.5 rounded-full text-[11px] uppercase tracking-wider whitespace-nowrap shadow-lg" data-id="element-80">
                ⭐ EL MÁS ELEGIDO
              </span>

              <div className="flex-1 text-left md:pr-4 flex flex-col justify-center mt-3 md:mt-0" data-id="element-81">
                <span className="block text-lg md:text-xl font-heading font-bold text-bg mb-1" data-id="element-82">
                  🏆 SISTEMA MAESTRO + PACK DE ACELERACIÓN
                </span>
                <span className="block text-sm text-bg/90 mb-1" data-id="element-83">
                  6 Módulos + 3 Bonos + Módulo 7
                </span>
              </div>

              <div className="flex flex-col items-center md:items-end justify-center shrink-0" data-id="element-84">
                <span aria-hidden="true" className="text-bg/60 line-through text-sm" data-id="element-85">
                  $97.910 ARS
                </span>
                <span className="text-4xl md:text-5xl font-heading font-bold text-bg leading-none" data-id="element-86">
                  $29.990
                </span>
                <span className="text-xs text-bg/80 mt-1" data-id="element-87">ARS</span>
              </div>

              <div className="hidden md:flex items-center shrink-0" data-id="element-88">
                <div className="py-4 px-6 rounded-xl font-bold text-gold bg-bg hover:bg-bg/90 transition-colors uppercase tracking-wider text-sm text-center whitespace-nowrap" data-id="element-89">
                  → QUIERO EL SISTEMA + PACK DE ACELERACIÓN
                </div>
              </div>
              <div className="w-full md:hidden mt-2" data-id="element-90">
                <div className="w-full py-3 px-4 rounded-xl font-bold text-gold bg-bg hover:bg-bg/90 transition-colors uppercase tracking-wider text-xs text-center" data-id="element-91">
                  → QUIERO EL SISTEMA + PACK DE ACELERACIÓN
                </div>
              </div>
            </a>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-92">
          <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-gray-400 mt-8" data-id="element-93">
            <div className="flex items-center gap-2" data-id="element-94">
              <span className="text-gold" aria-hidden="true" data-id="element-95">
                🛡️
              </span>
              <span data-id="element-96">Garantía 7 días</span>
            </div>
            <span className="text-white/10" aria-hidden="true" data-id="element-97">
              ·
            </span>
            <div className="flex items-center gap-2" data-id="element-98">
              <span className="text-gold" aria-hidden="true" data-id="element-99">
                ⚡
              </span>
              <span data-id="element-100">Acceso inmediato</span>
            </div>
            <span className="text-white/10" aria-hidden="true" data-id="element-101">
              ·
            </span>
            <div className="flex items-center gap-2" data-id="element-102">
              <span className="text-gold" aria-hidden="true" data-id="element-103">
                🔒
              </span>
              <span data-id="element-104">Pago 100% seguro</span>
            </div>
            <span className="text-white/10" aria-hidden="true" data-id="element-105">
              ·
            </span>
            <div className="flex items-center gap-2" data-id="element-106">
              <span className="text-gold" aria-hidden="true" data-id="element-107">
                💳
              </span>
              <span data-id="element-108">Mercado Pago | Tarjeta | Transferencia</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}